<template>
  <v-runtime-template :template="includeTemplate"/>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import { isEmpty } from 'lodash'

export default {
  name: 'Survey',
  components: {
    VRuntimeTemplate
  },
  data () {
    return {
      includeHtml: '',
      basePath: this.getStore('mmpAuth').state.basePath
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    }
  },
  watch: {
  },
  beforeUpdate () {
  },
  updated () {
  },
  async created () {
    if (isEmpty(wepHtmlToString.firstSubTemplate)) {
      this.getEmptyTemplate('wepSurvey.html')
    } else {
      this.includeHtml = wepHtmlToString.firstSubTemplate
    }
  },
  methods: {
    getEmptyTemplate (resourceUrl, next) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.firstSubTemplate = res
        this.includeHtml = wepHtmlToString.firstSubTemplate
      })
    },
    fnConfirm () {
      this.$emit('confirm', '1')
    },
    async fnNext () {
      this.fnTab('2')
    },
    async fnTab (arg) {
      let obj = {
        stepNum: arg,
        params: {}
      }

      obj.params = this.documentValidate()
      if (obj.params.flag) {
        let alertParams = { title: this.$t('WEP00008'), contents: this.$t('WEP00035'), okBtnNm: this.$t('WEP00006'), cancelBtnNm: this.$t('WEP00007') }
        let confirmRes = await this.$popup.confirm(this.$el, alertParams)
        if (confirmRes) {
          this.$emit('fnTab', obj)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/Survey.vue